const Login = () => import("./views/common/Login")
const Logout = () => import("./views/common/Logout")
const ChildRegister = () => import("./views/child/ChildRegister")

const publicRoutes = [{
  path: '/login',
  name: 'login',
  component: Login
}]

const privateRoutes = [
  {
    path: '/child-register',
    name: 'child-register',
    component: ChildRegister
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  }
]

export default router => {
  publicRoutes.forEach(element => {
    router.addRoute(element)
  });
  privateRoutes.forEach(element => {
    router.addRoute('main', element);
  })
};